<!--
 * @Author: cts 308360781@qq.com
 * @Date: 2025-06-22 18:56:07
 * @LastEditors: cts 308360781@qq.com
 * @LastEditTime: 2025-06-24 11:49:05
 * @FilePath: \web2\src\views\yunke\project\query.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-card class="box query">
    <el-form :model="query" ref="query" :inline="true">
      <el-form-item label="名称">
        <el-input
          v-model="query.q"
          placeholder="请输入楼盘名称"
          clearable
          style="width: 300px"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" round @click="onSearch" icon="search"
          >查询</el-button
        >
      </el-form-item>
    </el-form>
  </el-card>
  <el-card class="box data" v-loading="loading">
    <el-table
      ref="table"
      :data="tableData.data"
      border
      stripe
      @sort-change="onSort"
    >
      <el-table-column label="云客ID" prop="projId" width="340"></el-table-column>
      <el-table-column prop="projName" label="名称" width="240"></el-table-column>
      <el-table-column prop="exterResidentType" label="驻场类型" width="100">
        <template #default="{row}">
            {{ row.exterResidentType == 1 ? '驻场' : '经纪人'}}
        </template>
      </el-table-column>
      <el-table-column prop="orgCode" label="租户号" width="150"></el-table-column>
      <el-table-column prop="orgName" label="租户名称" width="200"></el-table-column>
      <el-table-column prop="companyName" label="公司名称" min-width="200"></el-table-column>
      
      <el-table-column prop="residentName" label="创建人" width="100"></el-table-column>
      <el-table-column prop="token" label="Token" width="180"></el-table-column>
    </el-table>
    <el-pagination
      @size-change="pageSizeChange"
      @current-change="pageCurrentChange"
      :current-page="query.pageIndex"
      :page-sizes="[20, 40, 60, 80, 100]"
      :page-size="query.pageSize"
      layout="total, sizes, prev, pager, next"
      :total="tableData.counts"
    ></el-pagination>
  </el-card>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      query: {
        pageIndex: 1,
        pageSize: 20,
        order: {
          sort: "",
          fieldName: "",
        },
        q: "",
      },
      tableData: {
        counts: 0,
      },
      is_can_edit: false,
      is_can_del: false,
    };
  },
  created() {
    this.is_can_edit = this.$power("admin/v1/estate/edit");
    this.is_can_del = this.$power("admin/v1/estate/del");
    this.loadData();
  },
  methods: {
    /**
     * 搜索
     */
    onSearch() {
      this.query.pageIndex = 1;
      this.loadData();
    },
    /**
     * 分页页数更改
     */
    pageSizeChange(val) {
      this.query.pageSize = val;
      this.loadData();
    },

    /**
     * 分页页码更改
     */
    pageCurrentChange(val) {
      this.query.pageIndex = val;
      this.loadData();
    },

    /**
     * 排序
     */
    onSort(e) {
      if (e.prop) {
        this.query.sort = {
          order: e.order,
          prop: e.prop,
        };
        this.loadData();
      }
    },

    /**
     *
     */
    loadData() {
      this.loading = true;
      this.$http
        .post("admin/v1/yunkeproject", this.query)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data;
          }
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>

<style scoped></style>
